import React from 'react';
import { useTranslations } from 'next-intl';
import styles from './ComingSoon.module.css';
import { CustomImage } from 'components/shared';

interface ComingSoonProps {
  variant?: 'dark' | 'light';
  className?: string;
  'aria-label'?: string;
}

const Container = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={className ? `${styles.container} ${className}` : styles.container}
    {...props}
  >
    {children}
  </div>
);

export const ComingSoon: React.FC<ComingSoonProps> = ({
  variant = 'dark',
  className,
  'aria-label': ariaLabelProp,
}) => {
  const t = useTranslations('uhHome');
  const ariaLabel = ariaLabelProp ?? t('comingSoon.ariaLabel');
  const imageSrc =
    variant === 'dark'
      ? 'web_v2/uh-home-v2/misc/coming-soon-dark.png'
      : 'web_v2/uh-home-v2/misc/coming-soon-light.png';

  return (
    <Container
      className={className}
      aria-label={ariaLabel}
      role="status"
      aria-live="polite"
    >
      <CustomImage src={imageSrc} alt={ariaLabel} width={416} height={164} />
    </Container>
  );
};
